export type PortalActivityListKind = 'courses' | 'personal_memberships'
export interface PortalCourseRow {
  person: string | null
  person_status: 'current' | 'former' | 'erased'
  course: string
  status: 'completed' | 'in_progress'
  completed_on: string | null
  grade: string | null
  credits: string | null
}
export interface PortalPersonalMembershipRow {
  person: string
  level: string
}
export interface PortalActivityListData {
  rows: Array<PortalCourseRow | PortalPersonalMembershipRow>
  total: number
  available_total: number
  completed?: number
  in_progress?: number
  levels?: string[]
  pagination: { caption: string; next_cursor: string | null; previous_cursor: string | null }
}
export type PortalActivityListResponse = Partial<
  Record<PortalActivityListKind, PortalActivityListData>
>
export const portalActivityLabels = {
  courses: { title: 'Courses', empty: 'No courses yet', search: 'Person or course' },
  personal_memberships: {
    title: 'Personal memberships',
    empty: 'No personal memberships yet',
    search: 'Person',
  },
}
